<template>
<b-col id="caseSummaries" md="10" sm="12">
  <slot name="header"></slot>
  <b-overlay :show="loading" z-index="1050" bg-color="#e0e0e0" :no-center="true">
    <template #overlay>
      <div class="text-center">
        <h5 class="loading shadow text-dark">Loading Results...</h5>
      </div>
    </template>
    <b-card class="caseSummaryContent">
      <b-row>
        <b-col lg="2" md="4" class="filter">
          <slot name="caseBlockFilter"></slot>
        </b-col>
        <b-col lg="10" md="8" class="printArea">
          <slot name="printArea"></slot>
          <slot name="caseBlock"></slot>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</b-col>
</template>

<script>
export default {
  props: ['loading']
}
</script>
<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Nunito&display=swap');

* {
  font-family: Nunito, freight-sans-pro, Sans Source;
}

ul {
  list-style: none;
}

body {
  background-color: white;
}

label {

}
h5.loading {
  opacity: 0.5;
  font-weight: bold;
  width: 100%;
  padding: 0.5rem;
  background-color: #ffc107;
  color: #343a40;
  font-style: italic;
}

.filter {
border-right: 0.1rem solid black;
}

.datePicker {
background-color: white !important;
border: 1px solid #ced4da !important;
}

fieldset.form-group, label {
  margin-bottom: 0 !important;
}

.form-group > label {
  padding-bottom: 0.3rem;
}

.vdp-datepicker .input-group-text {
border-radius:  0 .25rem .25rem 0   !important;
}


span.input-group-text,
.vdp-datepicker__calendar {
  font-size: 0.5rem;
}

form p {
margin-top: 0;
margin-bottom: 1rem;
}


.filteredCasesLabel {
font-size: 0.7rem;
}

.btn.reset-button {
font-size: 0.7rem;
padding: 2%;
-webkit-border-radius: 0.2rem;
border-radius: 0.2rem
}



.card.caseSummaryContent {
  background-color: #e0e0e0;
  max-height: 45.45rem;
  overflow-y: scroll;
}

.card .card-body {
  padding: 0.25rem 1rem 1rem;
}

.form-group label,
.custom-select,
.datePicker {
font-size: 0.5rem !important;
}

p.collapsible {
  font-style: italic;
  width: 100%;
  background: lightgray;
  color: white;
  padding: 1%;
}

.collapsible:after {
  content: "\2212";
  font-weight: bold;
  float: right;
  /* margin-left: 5px; */
  margin-left: 0.2rem;
}

.collapsible.active {
  background: gray;
}

.container-fluid {
  background-color: transparent;
  padding: 0 1%;
  font-family: "Nunito", sans-serif;
}

.caseNumbers {
  font-style: italic;
  font-family: "Nunito", sans-serif;
}

.ratings {
  /* padding-left: 15px;
  padding-right: 15px; */
  padding-left: 0.7rem;
  padding-right: 0.7rem;
}

.case-text {
  border-left: 0.05rem solid #cecac8;
}

.positive {
  color: #395a94;
}

.figure-caption {
  width: 100%;
  text-align: center;
  font-style: italic;
}

.reportLabel {
  font-family: "Nunito", Arial, sans-serif;
}

#filterApplied {
  display: none;
}

.case-text .reportLabel {
  color: #b79d61;
}

.case-block .reportLabel {
  font-size: 0.8rem;
}

@media print {
  .card.caseSummaryContent {
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    background-color: white;
    border: none;
  }

  #caseSummaries,
  .printArea {
    min-width: 100%;
  }

  .case-info {
    max-width: 15%;
  }

  .navigation,
  .filter,
  .custom-control.custom-switch,
  #overlay,
  .row.top-banner,
  body>div.elementor.elementor-3614.elementor-location-header,
  body>div.elementor.elementor-4769>div>div>section>div>div>div>div>div>div.elementor-element.elementor-element-853e7b7.elementor-nav-menu--indicator-classic.elementor-nav-menu--dropdown-tablet.elementor-nav-menu__text-align-aside.elementor-nav-menu--toggle.elementor-nav-menu--burger.elementor-widget.elementor-widget-nav-menu,
  body>div.elementor.elementor-336.elementor-location-footer {
    display: none !important;
  }

  .dot,
  .dot.poor,
  .dot.superior,
  .dot.satisfactory,
  .caseRating {
    -webkit-print-color-adjust: exact;
  }

  #filterApplied {
    display: block;
  }

  #app {
    background-image: none;
  }
}
</style>
